import { Button, Center, Heading, Text, VStack } from '@chakra-ui/react';
import { Link } from 'react-router';

type Props = { titel: string; tekst?: string };

/** Een korte melding midden in beeld met een weg terug naar het beginscherm. */
export function Melding({ titel, tekst }: Props) {
  return (
    <Center h="full" p="6">
      <VStack gap="4" textAlign="center" maxW="lg">
        <Heading as="h1" size="xl">
          {titel}
        </Heading>
        {tekst && <Text>{tekst}</Text>}
        <Button asChild>
          <Link to="/">Naar het beginscherm</Link>
        </Button>
      </VStack>
    </Center>
  );
}
